import { gql } from "@apollo/client";

export const GET_ANIMAL_GROUPS_INFO = gql`
  query AnimalGroup($domain: String!, $input: PanelBasicQueryInfoInput!, $ifIncludeAnimalCount: Boolean!) {
    animalGroup {
      animalGroup(domain: $domain, input: $input) {
        name
        animal_group_id
        animalsCount(domain: $domain) @include(if: $ifIncludeAnimalCount)
      }
    }
  }
`

export type AnimalGroupInfo = {
  name: string;
  animalGroupId: number,
  animalsCount?: number,
};
 
export interface AnimalGroupResponse {
  animalGroup: {
    animalGroup: AnimalGroupInfo[]
  }
}
